export const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  desktop: 1200
}

export const EMITTER_PROPS = {
  cart: {
    add: 'cart.add',
    update: 'cart.update',
    clear: 'cart.clear',
    change: 'cart.change',
    render: 'cart.render',
    updateB2b: 'cart.update_b2b'
  },
  product: {
    updateVariant: 'product.update_variant',
    openModalGallery: 'product.open_modal_gallery',
    addToCartError: 'product.add_to_cart_error',
    addToCartB2bError: 'product.add_to_cart_b2b_error',
    notify: 'product.notify'
  },
  notice: {
    global: 'notice.global'
  },
  wishlist: {
    list: 'wishlist.list',
    change: 'wishlist.change',
    updateIcon: 'wishlist.update_icon',
    changeInspiration: 'wishlist.change_inspiration'
  },
  bride: {
    openModal: 'bride.open_modal'
  }
}

export const WISHLIST_CONFIG = {
  sessionKey: 'wishlist-product-items',
  localStorage: 'wishlist-insprations',
  products: 'products',
  inspiration: 'inspiration'
}

export const RECENTLY_CONFIG = {
  cookieName: 'kyha_recently_viewed', // Please change prefix every new project 'gamma_' to project name
  cookieSkusName: 'gamma_recently_viewed_skus', // Please change prefix every new project 'gamma_' to project name
  expireTime: 60 * 60 * 24 * 7, // set cookie expire time to 7 days
  maxLimit: 10
}

export const OPTION_NAMES = {
  SIZE: 'Size',
  COLOR: 'Color',
  COLOUR: 'Colour'
}

export const GRID_VIEW = {
  small: 'small',
  big: 'big',
  localStorage: 'collection_grid_view'
}
